import React from "react";
import { useNavigate } from 'react-router-dom';
import gifSuccess from "../../../assets/Form/ic_success_done.gif"; // Import your GIF here

interface ModalRegisterProps {
  isOpen: boolean;
}

const ModalRegister: React.FC<ModalRegisterProps> = ({ isOpen }) => {
    const navigate = useNavigate();
    const handleBackToHome = () => {
        navigate('/');
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full text-center mx-4 md:mx-8">
                {/* Title */}
                <h2 className="text-xl font-bold mb-4 font-poppins">Data Telah Terkirim</h2>

                {/* GIF */}
                <div className="flex items-center justify-center mb-4">
                    <div className="w-20 h-20">
                        <img src={gifSuccess} alt="Success Animation" className="w-full h-full object-contain" />
                    </div>
                </div>

                {/* Description */}
                <p className="text-gray-600 mb-6 text-xs font-poppins">
                    Tim kami akan segera menghubungi anda, untuk proses pengecekan coverage area.
                </p>

                {/* Button */}
                <button
                    onClick={handleBackToHome}
                    className="bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600 font-poppins"
                >
                    Home
                </button>
            </div>
        </div>
    );
};

export default ModalRegister;